/**
 * Created by mvasim on 12/9/17.
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  FnTableConfig,
  TABLE_ACTION_TYPE,
  TableAction,
} from './fn-table.config';

import { FnTableMetaData } from './fn-table.meta.data';
import { FnUtilService } from '../../services/fn-util.service';
import { Subject } from 'rxjs';
import { TemplateRef } from '@angular/core';
import { hwObject } from '../../util/types';

/**
 * This Component is used to Create Table .
 * To use this component import FoundationModule in Module.
 */
@Component({
  selector: 'fn-table',
  templateUrl: 'fn-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FnTableComponent implements OnInit, OnDestroy {
  constructor(
    private fnUtil: FnUtilService,
    private cdRef: ChangeDetectorRef
  ) { }

  private static DEFAULT_SORT_CLS = '';

  /**
   * member varible
   * used to provide Search Config to FNTableSearchComponent
   */
  tblSearchConfig = {
    actionClear: new Subject<boolean>(),
  };
  /**
   * private member of type FNTableMetaData
   * used to default sort data by selectedCol
   */
  private selectedCol: FnTableMetaData;

  /**
   * public member of string type
   * used to filter table Row Object
   */
  public searchTerm: string;
  /**
   * Unique key exits of fn table component
   */
  private uniquKeyExits: boolean;
  /**
   * member variable
   * used for storing filter Row Data
   */
  public filterArray: Array<object>;
  /**
   * member variable
   * FnTableConfig object used set table properties
   */
  @Input() config: FnTableConfig;
  /**
   * Input  of fn table component
   */
  @Input() rowMetaArray: Array<FnTableMetaData>;

  /**
   * table Row MetaData Array used to copy ref of rowMeta Data
   * and also used in ui create table header
   */
  _rowMetaArray: Array<FnTableMetaData>;

  /**
   * total num of column
   * and also used in ui create table header
   */
  _rowMetaArraySize = 0;

  /**
   * Input member variable
   * used to store table row data
   */
  @Input() dataArray: Array<any>;
  /**
   * Input member variable
   * used to show current page of table
   */
  @Input() currentPage?: number;
  /**
   * Input  member variable
   * used to no of row in single page of table
   */
  @Input() pageSize?: number;
  
  /**
   * Input  member variable
   * used to show Footer data in table
   */

  @Input() footerRowObj?: hwObject;

  /**
   * Input  member variable
   * used for footer custom Class
   */

  @Input() footerclass?: string;
  /**
   * Output member method
   * emit event when table row updated
   */
  @Output() updateRow = new EventEmitter();
  /**
   * Output member method
   * emit event when table row deleted
   */
  @Output() deleteRow = new EventEmitter();


   /**
   * Output member method
   * emit event when any change Event
   */
 @Output() footerCallback = new EventEmitter<object[]>();

  @ContentChild('customTempRef') customTempRef: TemplateRef<any>;

  /**
   * variable to show total no. of page in table pagination
   */
  totalPage: number;
  /**
   * varible to show search box Action row if true
   */
  showSearchBox: boolean;
  /**
   * varible to clone row array to show in single page
   */
  dataCloneArray: Array<object>;

  /**
   * Implementing ngOnDestory to unsubscribe table action
   * and triger actionClear complete function
   */
  ngOnDestroy(): void {
    this.config.tableAction.unsubscribe();
    this.tblSearchConfig.actionClear.complete();
  }

  /**
   * method to initalize table page properties
   */
  private initPageConfig() {
    if (this.fnUtil.isEmptyObject(this.config.hidePagination)) {
      this.config.hidePagination = false;
    }
    if (!this.config.hidePagination) {
      this.currentPage = 1;
      this.pageSize = this.fnUtil.isEmptyObject(this.pageSize)
        ? 10
        : this.pageSize;
      this.calTotalPageSize(this.dataArray);
    } else {
      this.currentPage = 1;
      this.pageSize = this.dataArray.length;
      this.totalPage = 1;
    }
    if (this.fnUtil.isEmptyObject(this.config.uniqueKey)) {
      this.config.uniqueKey = 'primaryKey';
    }
    const _tempMetaHash: any = this.fnUtil.mapFromArray(this._rowMetaArray, 'key');
    this.uniquKeyExits = !this.fnUtil.isEmptyObject(
      _tempMetaHash[this.config.uniqueKey]
    );
  }

  /*
   *  Update action- triggerd manualy from Parent component
   */

  private updateTrigger = (returnRow: Array<any>) => {
    for (const key in this.dataArray) {
      if (
        this.uniquKeyExits &&
        this.dataArray[key][this.config.uniqueKey] ===
        returnRow[this.config.uniqueKey]
      ) {
        this.dataArray[key] = returnRow;
        break;
      }
    }
    this.tblSearchConfig.actionClear.next(true);
    this.searchOnRows(this.searchTerm, false);
  };

  /*
   *  Delete action- triggerd manualy from Parent component
   */
  private deleteTrigger = (returnRow: Array<any>) => {
    for (const index in this.dataArray) {
      if (
        this.uniquKeyExits &&
        this.dataArray[index][this.config.uniqueKey] ===
        returnRow[this.config.uniqueKey]
      ) {
        // tslint:disable-next-line:radix
        this.dataArray.splice(parseInt(index), 1);
        break;
      }
    }
    if (this.dataCloneArray.length === 1 && this.currentPage !== 1) {
      this.currentPage -= 1;
    }
    this.tblSearchConfig.actionClear.next(true);
    this.searchOnRows(this.searchTerm, false);
    this.cdRef.detectChanges();
  };

  /*
   *  Action triggerd manualy from Parent component
   */

  tableAction = (tableAction: TableAction) => {
    if (tableAction.action === TABLE_ACTION_TYPE.ADD) {
      this.addRowAction(tableAction.data);
    } else if (tableAction.action === TABLE_ACTION_TYPE.UPDATE) {
      this.updateTrigger(tableAction.data);
    } else if (tableAction.action === TABLE_ACTION_TYPE.DELETE) {
      this.deleteTrigger(tableAction.data);
    } else if (tableAction.action === TABLE_ACTION_TYPE.REFRESH) {
      this.updateDataArray(tableAction.data);
      this.cdRef.markForCheck();
    } else if (tableAction.action === TABLE_ACTION_TYPE.CLEAR_SEARCH) {
      this.searchTerm = '';
      this.showSearchBox = false;
      this.tblSearchConfig.actionClear.next(true);
      this.searchOnRows(this.searchTerm, false);
    } else {
      // todo
    }
    if (this.searchTerm?.length > 0) {
      this.showSearchBox = false;
      this.toggleSearch();
    }

    // detect change on UI becuase we are using onpush strategy
    this.cdRef.detectChanges();
  };

  /**
   * method to subscribe tableAction method
   */
  ngOnInit() {
    this.config.tableAction.subscribe(this.tableAction);
    this.setTableDefaultData();
  }
  /**
   * method to set default table configurations
   */
  private setTableDefaultData() {
    this.copyMetaDataArray();
    this.filterArray = this.dataArray;
    this.initPageConfig();
    for (let index = 0; index < this._rowMetaArray.length; index++) {
      this._rowMetaArray[index].sortValue = this.fnUtil.isEmptyObject(
        this._rowMetaArray[index].sortValue
      )
        ? FnTableConfig.defaultSortValue
        : this._rowMetaArray[index].sortValue;

      if (this.fnUtil.isEmptyObject(this._rowMetaArray[index].isSortable)) {
        this._rowMetaArray[index].isSortable = FnTableConfig.defaultIsColSort;
      }
      if (this.config.defaultSortKey === this._rowMetaArray[index].key) {
        this.selectedCol = this._rowMetaArray[index];
      }
    }
    if (this.config.defaultSortKey) {
      // this.applySortIcon(this.config.defaultSortKey);
      this.resetDataArray(this.selectedCol);
    }
  }

  public applySortIcon(sortKey: string): void {
    for (const index in this._rowMetaArray) {
      if (this._rowMetaArray[index].key === sortKey) {
        if (this._rowMetaArray[index].sortValue === 0) {
          this._rowMetaArray[index].sortValue = 1;
          this._rowMetaArray[index].sortCls = ' fn-global-sort';
        } else {
          this._rowMetaArray[index].sortValue =
            this._rowMetaArray[index].sortValue === 1 ? -1 : 1;
          this._rowMetaArray[index].sortCls =
            this._rowMetaArray[index].sortValue === 1
              ? ' fn-global-sort-desc'
              : ' fn-global-sort-asc';
        }
      } else {
        this._rowMetaArray[index].sortCls = FnTableConfig.defalutSortClass;
        this._rowMetaArray[index].sortValue = FnTableConfig.defaultSortValue;
      }
    }
  }

  public resetDataArray(column: FnTableMetaData, skipSortIcon?: boolean) {
    this.selectedCol = column;
    if (!skipSortIcon) {
      this.applySortIcon(column.key);
    }
    const _key = column.sortValue < 0 ? '-' + column.key : column.key;

    const tempArray = this.fnUtil.sortObjectOnKeys(this.filterArray, _key, true);
    const startSize = (this.currentPage - 1) * this.pageSize;
    this.dataCloneArray = tempArray.slice(startSize, startSize + this.pageSize);
    this.resetFooter();
  }

  public changeSort(column: FnTableMetaData): void {
    if (!column.isSortable) {
      return;
    }
    this.resetDataArray(column);
  }

  public paginzationEvent(eventObj: any) {
    this.currentPage = eventObj;
    this.resetDataArray(this.selectedCol, true);
  }

  public searchOnRows(_searchTerm?: string, calPagination = true) {
    /* if (calPagination) {
        this.currentPage = 1;
    } */
    if (this.fnUtil.isEmptyObject(_searchTerm)) {
      this.filterArray = this.dataArray;
      this.calTotalPageSize(this.filterArray);
    } else {
      this.filterArray = this.fnUtil.filterArray(
        this.dataArray,
        _searchTerm,
        true
      );
      this.currentPage = 1;
      this.calTotalPageSize(this.filterArray);
    }

    this.resetDataArray(this.selectedCol, true);
  }

  addRowAction(rowObj: object) {
    this.showSearchBox = false;
    this.dataArray.push(rowObj);
    this.tblSearchConfig.actionClear.next(true);
    this.searchOnRows(this.searchTerm, false);
  }

  public filterAction(rowArray: Array<object>) {
    this.dataArray = rowArray;
    this.searchTerm = '';
    this.searchOnRows();
  }

  updateDataArray = (dataArray: Array<any>) => {
    this.dataArray = dataArray;
    this.setTableDefaultData();
  };

  public cellClick(rowObj: object, columnName: string) {
    this.updateAction(rowObj);
  }
  updateAction = (rowObj: object) => {
    this.showSearchBox = false;
    this.updateRow.emit(rowObj);
    this.tblSearchConfig.actionClear.next(true);
    this.searchOnRows(this.searchTerm, false);
  };

  deleteAction = (rowObj: object) => {
    this.showSearchBox = false;
    this.deleteRow.emit(rowObj);
    this.tblSearchConfig.actionClear.next(true);
    this.searchOnRows(this.searchTerm, false);
  };

  public toggleSearch(event?: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.searchTerm = '';
    if (this.showSearchBox) {
      this.searchTerm = '';
      this.tblSearchConfig.actionClear.next(false);
    }
    this.searchOnRows();
    this.showSearchBox = !this.showSearchBox;
  }

  closeSearch(event: any) {
    this.toggleSearch();
  }
  private calTotalPageSize(arr: any) {
    this.totalPage = Math.ceil(arr.length / this.pageSize);
  }
  private copyMetaDataArray() {
    this._rowMetaArray = [];
    this._rowMetaArraySize = this.rowMetaArray.length - 1;
    for (let i = 0; i <= this._rowMetaArraySize; i++) {
      this._rowMetaArray.push({ ...this.rowMetaArray[i] });
    }

  }

  private resetFooter(){
    this.footerCallback.emit(this.dataCloneArray);
  }

  openRowExpand(rowObj: any){
    rowObj.isShowExpandDetail = !rowObj.isShowExpandDetail;
  }
}
